export const FIELD_VARIANTS = {
  ROW: 'row',
  COLUMN: 'column'
}

export const AUTHOR_VARIANTS = {
  DEFAULT: 'default',
  COMPACT: 'compact'
}

export const CHECKIN_PREVIEW_ACTIONS_PLACEMENTS = {
  HEADER: 'header',
  AFTER_COMMENT: 'after-comment'
}
